export default __webpack_public_path__ + "static/media/mesure.b4b093b4.jpg";